import { render, staticRenderFns } from "./BasicWysiwygEntry.vue?vue&type=template&id=4f1e7ba8"
import script from "./BasicWysiwygEntry.vue?vue&type=script&lang=ts"
export * from "./BasicWysiwygEntry.vue?vue&type=script&lang=ts"
import style0 from "./BasicWysiwygEntry.vue?vue&type=style&index=0&id=4f1e7ba8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports